import Box from "@mui/material/Box";
import eglogo from "../assets/logo.png";

export const BrandingLogo = () => (
  <Box
    sx={(theme) => ({
      backgroundColor: theme.general.logoBg,
      borderRadius: 1,
      padding: 1,
      marginLeft: theme.spacing(2),
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      alignSelf: "flex-start",
      maxHeight: 60,
      maxWidth: 128,
    })}
  >
    <img src={eglogo} alt="Logo" style={{ maxHeight: "100%", maxWidth: "100%" }} />
  </Box>
);
